import React from "react";
import { UnderlineSketch, SectionFrame } from "../kits/DesignKit";
import { useInsertName } from "./utils/helpers";

const ContactIntroSection = () => {
  const name = useInsertName();

  return (
    <SectionFrame className="pt-32 pb-16 sm:pt-36 sm:pb-20 md:pt-40 md:pb-24">
      <div className="container mx-auto text-center px-6 max-w-4xl">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-mono text-gray-900 mb-6 leading-relaxed">
          Sag{" "}
          <span className="relative inline-block" style={{ color: '#AC8E66' }}>
            Hallo
            <UnderlineSketch
              className="absolute -bottom-1 left-0 w-full h-2"
              color="zenBrand"
            />
          </span>
          ,{" "}
          <span className="relative inline-block" style={{ color: '#AC8E66' }}>
            {name}
            <UnderlineSketch
              className="absolute -bottom-1 left-0 w-full h-2"
              color="zenBrand"
            />
          </span>{" "}
          :)
          <br />
          und lass uns{" "}
          <span className="relative inline-block" style={{ color: '#AC8E66' }}>
            schnacken
            <UnderlineSketch
              className="absolute -bottom-1 left-0 w-full h-2"
              color="zenBrand"
            />
          </span>
          !
        </h1>
        <p className="text-sm sm:text-base font-mono text-gray-600 max-w-2xl mx-auto">
          Ob Fragen zu Projekten oder einfach nur für ein Moin.
          <br />
          Authentisch. Echt. Einfach.
        </p>
      </div>
    </SectionFrame>
  );
};

export default ContactIntroSection;
